var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.workersLoading)?_c('div',[_c('BlockHorizontalList',{attrs:{"background-color":"light","title":"Fler medarbetare","type":"workers","workers":_vm.filteredWorkers}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }